module.exports = __webpack_public_path__ + "static/media/monkey.e5093ba1.svg";